import { createClient } from '@supabase/supabase-js';

import { env } from './env.js';

/**
 * ブラウザ用 Supabase クライアント。
 *
 * 用途は 2 つだけ。
 *   1. 認証（ログイン / ログアウト / セッション復元）
 *   2. 自分の提出の Realtime 購読 (SPEC 59)
 *
 * データの読み書きは API 経由で行う。
 * anon key で直接テーブルを触ると、可視性の判断が
 * RLS と API の 2 か所に分散してしまうため。
 */
export const supabase = createClient(env.supabaseUrl, env.supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storageKey: 'coderush.auth',
  },
});
